export class OrderStates {
    static PENDING = 1;
    static IN_PRODUCTION = 2;
    static PRODUCED = 3;
    static QUEUED = 4;
}

export class ProductionControlModals {
    static ORDER_REFERENCE_VIEW = 'order_reference_view'
    static ALARMS = 'alarms'
}
